import React, { createContext, useContext, useEffect, useState } from 'react';
export const THEME_KEY = 'mekanda_theme';
const valid = value => ['light', 'dark', 'system'].includes(value) ? value : 'light';
export const readTheme = () => { try { return valid(localStorage.getItem(THEME_KEY)); } catch { return 'light'; } };
const systemDark = () => !!window.matchMedia?.('(prefers-color-scheme: dark)').matches;
const ThemeContext = createContext({ preference: 'light', resolved: 'light', setPreference: () => {} });
export const useTheme = () => useContext(ThemeContext);
export function ThemeProvider({ children }) {
  const [preference, updatePreference] = useState(readTheme);
  const [darkSystem, setDarkSystem] = useState(systemDark);
  const resolved = preference === 'system' ? (darkSystem ? 'dark' : 'light') : preference;
  const setPreference = value => {
    const next = valid(value); updatePreference(next);
    try { localStorage.setItem(THEME_KEY, next); } catch { /* Still works for this session. */ }
  };
  useEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    const change = event => setDarkSystem(event.matches);
    media?.addEventListener('change', change);
    const sync = event => { if (event.key === THEME_KEY || event.key === null) updatePreference(readTheme()); };
    window.addEventListener('storage', sync);
    return () => { media?.removeEventListener('change', change); window.removeEventListener('storage', sync); };
  }, []);
  useEffect(() => {
    document.documentElement.dataset.theme = resolved;
    document.documentElement.classList.toggle('dark', resolved === 'dark');
    document.documentElement.style.colorScheme = resolved;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', resolved === 'dark' ? '#171b22' : '#f7f8fa');
  }, [resolved]);
  return <ThemeContext.Provider value={{ preference, resolved, setPreference }}>{children}</ThemeContext.Provider>;
}
